import { render } from "./KeywordMix.vue?vue&type=template&id=960c30b6"
import script from "./KeywordMix.vue?vue&type=script&lang=js"
export * from "./KeywordMix.vue?vue&type=script&lang=js"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__